import type { Provider } from '@angular/core';
import type { MicroNgConfig } from '@eliboo/micro-ng/core';
import type { ElibooMicroConfig } from '@eliboo/shared/micro-ng';

import { inject } from '@angular/core';
import { useApiGetLicenseUserInfo } from '@eliboo/api/nuas-app';
import { provideMicroNg } from '@eliboo/micro-ng/init';
import { APP_HTTP_OPTIONS, ELIBOO_MICRO_CONFIG, getAlainAuthConfig } from '@eliboo/shared/micro-ng';

import type { TaxEnvironment } from './environments';

import { useApiOptions } from './api/api-options';
import { ChannelApiService } from './api/channel/channel-api.service';
import { TAX_ENVIRONMENT } from './environments';
import { TaxRouteService } from './route';
import { AppStoreService, TaxDeclareService, TaxUserService } from './service';
import { TaxService } from './service/tax.service';

export function provideTaxService({
  routeHost,
  env,
  microNgConfig,
  userCacheKey,
  fasterInit,
  provides,
}: {
  env: TaxEnvironment;
  fasterInit?: boolean;
  microNgConfig: MicroNgConfig;
  routeHost: string;
  userCacheKey?: string;
  provides?: {
    TaxUserService: Provider;
  };
}): Provider[] {
  const elibooMicroNgProvides: Provider[] = [
    { provide: APP_HTTP_OPTIONS, useFactory: () => useApiOptions() },
    {
      provide: ELIBOO_MICRO_CONFIG,
      useFactory: () => {
        const elibooMicroConfig: ElibooMicroConfig = {
          userService: {
            userCacheKey: userCacheKey ?? 'tax_user',
            fasterInit: fasterInit,
            apis: {
              getUserInfo: useApiGetLicenseUserInfo(inject(APP_HTTP_OPTIONS)).api,
            },
          },
        };
        return elibooMicroConfig;
      },
    },
    provides?.TaxUserService ?? TaxUserService,
  ];

  return [
    provideMicroNg({
      routeHost,
      alainAuthConfig: getAlainAuthConfig({ store_key: '_tax_service_token', ...(env.alainAuthConfig ?? {}) }),
      microNgConfig,
      MicroRouterServiceClass: TaxRouteService,
    }),
    ...elibooMicroNgProvides,
    { provide: TAX_ENVIRONMENT, useValue: env },
    AppStoreService,
    TaxService,
    ChannelApiService,
    TaxDeclareService,
  ];
}
